import { AIChatCurrency } from 'src/typings/ai-chat';

const AI_CHAT_CURRENCY_ALIASES: Record<string, AIChatCurrency> = {
  US$: 'USD',
  USD: 'USD',
  $: 'USD',
  EUR: 'EUR',
  '€': 'EUR',
  GBP: 'GBP',
  '£': 'GBP',
  PLN: 'PLN',
  ZŁ: 'PLN',
  ZL: 'PLN',
  UAH: 'UAH',
  '₴': 'UAH',
  ГРН: 'UAH',
};

const DOLLAR_ALIASES = /(^|[^A-Z])(?:US\$|\$)/;
const SYMBOL_ALIASES = ['€', '£', '₴'];
const WORD_ALIASES = ['ZŁ', 'ZL', 'ГРН'];
const TOKEN_SEPARATOR = '[\\s,.;:()\\[\\]{}]';
const CURRENCY_CODE = /^[A-Z]{3}$/;
const CURRENCY_CODE_IN_TEXT = /(^|[^A-Za-z])([A-Z]{3})(?=$|[^A-Za-z])/;

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const normalizeAIChatCurrency = (value: string): AIChatCurrency | null => {
  const trimmed = value.trim().replace(/[.,:;]+$/, '');
  if (CURRENCY_CODE.test(trimmed)) return trimmed;
  const normalized = trimmed.toLocaleUpperCase();
  return AI_CHAT_CURRENCY_ALIASES[normalized] || null;
};

export const extractAIChatCurrency = (value: unknown): AIChatCurrency | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const code = CURRENCY_CODE_IN_TEXT.exec(trimmed)?.[2];
  if (code) return code;

  const normalized = trimmed.toLocaleUpperCase();

  if (DOLLAR_ALIASES.test(normalized)) return 'USD';

  const symbol = SYMBOL_ALIASES.find((alias) => normalized.includes(alias));
  if (symbol) return AI_CHAT_CURRENCY_ALIASES[symbol];

  const word = WORD_ALIASES.find((alias) => new RegExp(
    `(^|${TOKEN_SEPARATOR})${escapeRegExp(alias)}(?=$|${TOKEN_SEPARATOR})`,
  ).test(normalized));
  return word ? AI_CHAT_CURRENCY_ALIASES[word] : null;
};
